import apiConfig from "../../apiConfig";

export const setTypeStatus = async (at, typeId, statusId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Types/Set_Donation_Type",
		{
			Donation_Type_Id: typeId,
			Active_Status_Id: statusId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
